export default __webpack_public_path__ + "error47f400.png";